import './styles.css'

import ClinicNameRender from '@medical/components/ClinicNameRender/index.js'
import ConfirmationModal from '@medical/components/ConfirmationModal'
import EmploymentClassificationIcon from '@medical/components/EmploymentClassificationIcon/EmploymentClassificationIcon'
import CustomDropdown from '@medical/components/DropdownForSignup'
import InputTextarea from '@medical/components/InputTextarea'
import TextInput from '@medical/components/TextInput'
import { splitLogicReverse } from '@medical/libs'
import { formatExtendedTime } from '@medical/libs/extendedTimeUtils'
import numeralCurrency from '@medical/libs/numeralCurrency.js'
import ShiftFormSplits from '@medical/pages/staff/components/ShiftFormSplits'
import { isGuaranteeShiftClinicName } from '@medical/constant'
import { InputNumber, Switch } from 'antd'
import { ErrorMessage, FieldArray, Formik } from 'formik'
import moment from 'moment'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { Button } from 'primereact/button'
import { Checkbox } from 'primereact/checkbox'
import { InputText } from 'primereact/inputtext'
import { TabPanel, TabView } from 'primereact/tabview'
import React from 'react'
import * as Yup from 'yup'
import Editor from '@medical/components/Editor'
import Router from '@medical/routes/router'
import DetailAvailableShiftTemplateMail from '../DetailAvailableShift/DetailAvailableShiftTemplateMail'
import styles from './Style.js'
import { WorkScheduleComment } from './WorkScheduleComment.js'
import { WorkScheduleType } from './WorkScheduleType.js'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { Checkbox as CheckboxAntd } from 'antd'

const DetailWorkScheduleScene = ({
  i18n,
  onSubmit,
  workSchedule,
  // availableShifts,
  activitiesHistory,
  postUpdateHistory,
  staffMe,
  accept,
  cancel,
  reject,
  restore,
  update,
  isMoneyPermitted,
  isUpdatePermitted,
  isRejectPermitted,
  isCancelPermitted,
  isRestorePermitted,
  isAcceptPermitted,
  isAddPermitted,
  isDeletePermitted,
  isViewCountWorkScheduleDetailPermitted,
  isGoldWare,
  departmentNames,
  doctorHourlyWageRange,
  countDoctorWorkedInClinic,
  popup,
  isChangeConfirmedShiftsStatusPermitted,
  location,
  state,
  isDeleteAllComment,
  dataDoctorConsultationTime,
  handleUpdateShiftAllowMultipleApplication
}) => {
  const validationSchema = Yup.object().shape({
    date: Yup.date(i18n.t('validation.date.required')).required(
      i18n.t('validation.date.required')
    ),
    startTime: Yup.date('Should be string').required(''),
    splits: Yup.array().of(
      Yup.object().shape({
        date: Yup.date().required(i18n.t('validation.date.required')),
        hourlyWage: isMoneyPermitted
          ? Yup.number().required(i18n.t('validation.hourlyWage.required'))
          : undefined,
      })
    ),
    acceptedReason:
      !isGoldWare &&
      Yup.string()
        .nullable()
        .max(4500, i18n.t('validation.max', { max: 4500 })),
    deletedReason:
      !isGoldWare &&
      Yup.string()
        .nullable()
        .max(300, i18n.t('validation.max', { max: 300 })),
    rejectedReason: Yup.string().when('rejecting', {
      is: true,
      then: Yup.string()
        .required(
          `${i18n.t('main.deletedReason')}${i18n.t('validation.required')}`
        )
        .nullable()
        .max(300, i18n.t('validation.max', { max: 300 })),
      otherwise: Yup.string().nullable(),
    }),
    doctorSubsidy: Yup.array()
      .nullable()
      .of(
        Yup.object().shape({
          title: Yup.string()
            .nullable()
            .required(i18n.t('validation.doctorSubsidy')),
          money: Yup.number()
            .nullable()
            .required(i18n.t('validation.doctorSubsidy')),
        })
      ),
  })
  const optionsKnowAboutShift = [
    {
      value: 'DIRECT',
      description: '直接',
    },
    {
      value: 'REFERENCE_COMPANY',
      description: '紹介会社',
    },
    {
      value: 'OTHER',
      description: 'その他',
    },
  ]
  const actualTime = ws => {
    const result = []
    // Format each segment time as an extended time (24:00-26:00) relative to the
    // shift's start, so overnight segments show 25:30/26:00 instead of 01:30/02:00.
    const fmt = t => formatExtendedTime(ws.startTime, t)

    if (ws.splitDateTime1 && ws.splitDateTime2 && ws.splitDateTime3) {
      result.push(
        `${fmt(ws.startTime)}～${fmt(ws.splitDateTime1)} ${
          ws.isSplitDateTime1BreakTime ? '(休憩時間)' : ''
        }`
      )
      result.push(
        `${fmt(ws.splitDateTime1)}～${fmt(ws.splitDateTime2)} ${
          ws.isSplitDateTime2BreakTime ? '(休憩時間)' : ''
        }`
      )
      result.push(
        `${fmt(ws.splitDateTime2)}～${fmt(ws.splitDateTime3)} ${
          ws.isSplitDateTime3BreakTime ? '(休憩時間)' : ''
        }`
      )
      result.push(
        `${fmt(ws.splitDateTime3)}～${fmt(ws.endTime)} ${
          ws.isStartTimeBreakTime ? '(休憩時間)' : ''
        }`
      )
    } else if (ws.splitDateTime1 && ws.splitDateTime2) {
      result.push(
        `${fmt(ws.startTime)}～${fmt(ws.splitDateTime1)} ${
          ws.isSplitDateTime1BreakTime ? '(休憩時間)' : ''
        }`
      )
      result.push(
        `${fmt(ws.splitDateTime1)}～${fmt(ws.splitDateTime2)} ${
          ws.isSplitDateTime2BreakTime ? '(休憩時間)' : ''
        }`
      )
      result.push(
        `${fmt(ws.splitDateTime2)}～${fmt(ws.endTime)} ${
          ws.isStartTimeBreakTime ? '(休憩時間)' : ''
        }`
      )
    } else if (ws.splitDateTime1) {
      result.push(
        `${fmt(ws.startTime)}～${fmt(ws.splitDateTime1)} ${
          ws.isSplitDateTime1BreakTime ? '(休憩時間)' : ''
        }`
      )
      result.push(
        `${fmt(ws.splitDateTime1)}～${fmt(ws.endTime)} ${
          ws.isStartTimeBreakTime ? '(休憩時間)' : ''
        }`
      )
    } else {
      result.push(
        `${fmt(ws.startTime)}～${fmt(ws.endTime)} ${
          ws.isStartTimeBreakTime ? '(休憩時間)' : ''
        } `
      )
    }
    return result
  }
  const { doctor, accepted } = workSchedule
  const checkCountedDoctorLastWorkShift = lastWorkday => {
    if (lastWorkday) {
      const dateAfterEighteenMonths = moment(lastWorkday)
        .add(18, 'months')
        .startOf('D')
        .toISOString()
      const now = moment().toISOString()
      if (now > dateAfterEighteenMonths && !accepted) {
        return (
          <>
            <div
              style={{
                paddingLeft: '15px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
              }}
            >
              <span
                className='pi pi-exclamation-triangle'
                style={{ color: '#f7a444', fontSize: '36px' }}
              ></span>
              <span style={{ color: '#f84e51', fontWeight: '600' }}>
                前回のご勤務から一定期間経過している先生からの応募です。
              </span>
            </div>
          </>
        )
      }
    }
    return null
  }

  const doctorLink = doctorId => {
    return (
      <Link
        to={{
          pathname: `${Router.get(Router.staffDoctors, {})}${Router.get(
            Router.staffDoctorDetail,
            {
              doctorId: doctorId,
            }
          )}`,
        }}
        style={{ color: '#f84e51', fontWeight: 'bold' }}
        rel='noopener noreferrer'
        target='_blank'
      >
        <Button icon='pi pi-external-link' style={{ border: 'none' }} />
      </Link>
    )
  }
  const WorkScheduleActivityHistoryComponent = ({
    dataHistory,
    isActivitiesHistory,
  }) => {
    return (
      <>
        {dataHistory.map((it, k) => (
          <div key={k}>
            <span>
              {moment(it.createdAt)
                .startOf('day')
                .format('YYYY年MM月DD日')}
            </span>
            <span> {moment(it.createdAt).format('HH:mm')} </span>
            <span> {it.staff} </span>
            <span>
              {' '}
              {!isActivitiesHistory
                ? it.activity
                : i18n.t(`staff.activityLogsStaffHistory.${it.activity}`)}{' '}
            </span>
          </div>
        ))}
      </>
    )
  }

  return (
    <div>
      <Formik
        initialValues={{
          functionName: '',
          doctor: workSchedule.doctor,
          confirm: false,
          accepting: false,
          deleting: false,
          rejecting: false,
          updating: false,
          isSendMail: false,
          acceptingAlreadyApprove: false,
          acceptingAlreadyApproveComment: false,
          removeDoctorSubsidyIds: [],
          fullname: workSchedule.doctor.fullName,
          fullnameKana: workSchedule.doctor.fullNameKana,
          clinicalDepartment: workSchedule.clinicalDepartment,
          clinicName: ClinicNameRender({
            clinicalDepartment: workSchedule.clinicalDepartment,
          }),
          departmentName: workSchedule.clinicalDepartment.name,
          scheduleDate: moment(workSchedule.startTime).format('LL (dd)'),
          workScheduleComment: workSchedule.comment,
          date: moment(workSchedule.startTime).toDate(),
          startTime: moment(workSchedule.startTime).toDate(),
          splits: splitLogicReverse({
            availableShift: workSchedule.acceptedShift,
          }),
          deletedStatus: workSchedule.deletedStatus,
          accepted: workSchedule.accepted,
          deletedReason: workSchedule.deletedReason,
          rejectedReason: workSchedule.rejectedReason,
          acceptedReason:
            workSchedule.doctor.firstWorkday === null
              ? DetailAvailableShiftTemplateMail.props.children
              : workSchedule.acceptedReason,
          doctorWorkSchedules: workSchedule.doctorWorkSchedules,
          introductionHistory:
            workSchedule.acceptedShift.introductionHistory || '',
          introductionHistoryOther:
            workSchedule.acceptedShift.introductionHistoryOther || '',
          comment: workSchedule.acceptedShift.comment || '',
          doctorId: workSchedule.doctor.id || '',
          actualTime: workSchedule.workScheduleActualTime
            ? actualTime(workSchedule.workScheduleActualTime)
            : '',
          doctorSubsidy:
            workSchedule &&
            workSchedule.acceptedShift &&
            workSchedule.acceptedShift.doctorSubsidyExcludeDeletedValue
              ? workSchedule.acceptedShift.doctorSubsidyExcludeDeletedValue
              : [],
          endTime: moment(workSchedule.endTime),
          isSendIntroduceMess: false,
          isPublished:
            workSchedule && workSchedule.acceptedShift
              ? workSchedule.acceptedShift.isPublished
              : true,
          isDoubleRecruitment:
            workSchedule && workSchedule.acceptedShift
              ? workSchedule.acceptedShift.isDoubleRecruitment
              : true,
          isAllowMultipleApplications:
            workSchedule && workSchedule?.acceptedShift
              ? !!workSchedule?.acceptedShift?.isAllowMultipleApplications
              : false,
          updateIsAllowMultipleApplication: false,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        render={formikProps => {
          const {
            initialValues,
            values,
            validateForm,
            setTouched,
            dirty,
            touched,
            errors,
            setFieldValue,
          } = formikProps
          const isGuaranteeShift = isGuaranteeShiftClinicName(
            workSchedule.clinicalDepartment.clinic.name
          )
          let confirmationMessage
          switch (values.functionName) {
            case accept:
              confirmationMessage = i18n.t(
                'staff.workSchedule.acceptConfirmation'
              )
              break
            case cancel:
              confirmationMessage = isGuaranteeShift
                ? i18n.t('staff.workSchedule.cancelConfirmationNotSendMessage')
                : i18n.t('staff.workSchedule.cancelConfirmation')
              break
            case reject:
              confirmationMessage = i18n.t(
                'staff.workSchedule.rejectConfirmation'
              )
              break
            case update:
              confirmationMessage = !values.isSendMail
                ? i18n.t('staff.workSchedule.updateConfirmation')
                : i18n.t('staff.workSchedule.updateConfirmationNotSendMail')
              break
            case restore:
              confirmationMessage = i18n.t(
                'staff.workSchedule.restoreConfirmation'
              )
              break
            default:
              break
          }

          const validateAndConfirm = () =>
            validateForm().then(response => {
              if (!Object.keys(response).length) {
                setFieldValue('confirm', true)
              } else {
                setTouched(response)
              }
            })

          const CustomFooter = () => (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                label={'閉じる'}
                icon='pi pi-times'
                onClick={() => {
                  setFieldValue('acceptingAlreadyApproveComment', false)
                }}
                style={{ borderRadius: '5px' }}
                className='p-button-secondary'
              />
            </div>
          )
          return (
            <TabView>
              <TabPanel header={i18n.t('main.workScheduleDetailTab.detail')}>
                <div>
                  {values.deletedStatus === 'WORKSCHEDULE_CANCEL' ? (
                    <div className='modal-title'>
                      {i18n.t('main.status')}: {i18n.t('main.ACCEPTED')}
                      {i18n.t('main.cancel')}
                    </div>
                  ) : (
                    <div className='modal-title'>
                      {i18n.t('main.status')}:
                      {values.accepted
                        ? i18n.t('main.ACCEPTED')
                        : i18n.t('main.NOT_ACCEPTED')}
                      {i18n.t('main.shift')}
                    </div>
                  )}
                  {workSchedule.acceptedShift.name && (
                    <div className='tr'>
                      <div className='th'>{i18n.t('main.shiftTitle')}</div>
                      <div className='td' style={{ paddingLeft: '20px' }}>
                        {workSchedule.acceptedShift.name}
                      </div>
                    </div>
                  )}
                  <div className='tr'>
                    <div className='th'>{i18n.t('main.fullname')}</div>
                    <div
                      className='td'
                      style={{
                        paddingLeft: '20px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <EmploymentClassificationIcon
                        workPattern={workSchedule.doctor.workPattern}
                      />
                      {workSchedule.doctor.fullName}

                      {workSchedule.doctor.id
                        ? doctorLink(workSchedule.doctor.id)
                        : null}
                    </div>
                  </div>
                  <TextInput
                    {...formikProps}
                    name='fullnameKana'
                    label={i18n.t('main.fullnameKana')}
                    disabled
                    classDisabled
                  />
                  <TextInput
                    {...formikProps}
                    name='clinicName'
                    label={i18n.t('main.clinicName')}
                    disabled
                    classDisabled
                  />
                  <div className='tr'>
                    <div className='th'>{i18n.t('main.departmentName')}</div>
                    <div className='td' style={{ paddingLeft: '20px' }}>
                      {departmentNames[values.departmentName]}
                    </div>
                  </div>
                  <TextInput
                    {...formikProps}
                    name='scheduleDate'
                    label={i18n.t('main.scheduleDate')}
                    disabled
                    classDisabled
                  />
                  {!values.accepted &&
                    !!workSchedule.doctor?.countedDoctorLastWorkShift
                      ?.lastWorkday && (
                      <>
                        <div className={'tr'}>
                          <div
                            className={'th'}
                            style={{
                              color: 'red',
                            }}
                          >
                            最終勤務日
                          </div>
                          <div
                            className={'td'}
                            style={{
                              color: 'red',
                            }}
                          >
                            {moment(
                              doctor?.countedDoctorLastWorkShift?.lastWorkday
                            ).format('YYYY年MM月DD日')}
                          </div>
                        </div>
                        {checkCountedDoctorLastWorkShift(
                          doctor?.countedDoctorLastWorkShift?.lastWorkday
                        )}
                      </>
                    )}
                  {isMoneyPermitted ? (
                    <div className='tr'>
                      <div
                        style={{
                          color: 'red',
                        }}
                        className='th'
                      >
                        二診目登録
                      </div>
                      <div className='td checkbox-color-border'>
                        <CheckboxAntd
                          checked={values.isDoubleRecruitment}
                          onChange={e => {
                            setFieldValue(
                              'isDoubleRecruitment',
                              e.target.checked
                            )
                          }}
                        />
                      </div>
                    </div>
                  ) : null}
                  <InputTextarea
                    {...formikProps}
                    name='comment'
                    label={i18n.t('main.workDetail')}
                    autoResize
                    rows={8}
                  />
                  <div className='tr'>
                    <div className='th'>
                      {i18n.t('staff.scheduledShiftGroup.tittlePublished')}
                    </div>
                    <div className='td toggle-container'>
                      <Switch
                        name='isPublished'
                        checkedChildren={i18n.t(
                          'staff.scheduledShiftGroup.published'
                        )}
                        unCheckedChildren={i18n.t(
                          'staff.scheduledShiftGroup.notPublished'
                        )}
                        checked={values.isPublished}
                        onChange={e => {
                          if (isChangeConfirmedShiftsStatusPermitted) {
                            setFieldValue('isPublished', e)
                            if (!e.checked) {
                              setFieldValue('isSendMail', false)
                            }
                          } else {
                            popup.error(
                              i18n.t(
                                'staff.scheduledShiftGroup.errorMessagePermision'
                              )
                            )
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className={
                      workSchedule.comment
                        ? 'doctor-comment'
                        : 'doctor-no-comment'
                    }
                  >
                    {workSchedule.comment ? (
                      <div className='doctor-comment-container'>
                        <div className='th doctor-comment-title'>
                          {i18n.t('main.workScheduleComment')}
                        </div>
                        <br />
                        <div className='doctor-comment-content'>
                          <div className='comment-full'>
                            {workSchedule.comment}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className='doctor-comment-container'>
                        <div className='th doctor-comment-title'>
                          {i18n.t('main.workScheduleComment')}
                        </div>
                        <br />
                        <div className='doctor-comment-content'>
                          <div className='comment-empty'>
                            {i18n.t('main.staffComment.emptyComment')}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {isAddPermitted && (
                    <div className='staffpage-comment-container'>
                      <div className='staffpage-title'>
                        {i18n.t('main.staffComment.titleStaffComment')}
                      </div>
                      <WorkScheduleComment
                        comments={workSchedule.staffComments}
                        availableShiftGroupComment={
                          workSchedule.acceptedShift
                            .scheduledAvailableShiftGroup
                            ? workSchedule.acceptedShift
                                .scheduledAvailableShiftGroup.staffComments
                            : null
                        }
                        workScheduleId={workSchedule.id}
                        staffId={staffMe.id}
                        isMoneyPermitted={isMoneyPermitted}
                        isAddPermitted={isAddPermitted}
                        isDeletePermitted={isDeletePermitted}
                        isDeleteAllComment={isDeleteAllComment}
                      />
                    </div>
                  )}
                  <WorkScheduleType
                    type={workSchedule.acceptedShift.type || ''}
                    workScheduleId={workSchedule.acceptedShift.id}
                    staffId={staffMe.id}
                  />
                  <ShiftFormSplits
                    {...formikProps}
                    i18n={i18n}
                    disabled={values.deletedStatus}
                    classDisabled
                    isMoneyPermitted={isMoneyPermitted}
                    doctorHourlyWageRange={doctorHourlyWageRange}
                    isDetailWorkSchedule={true}
                    dataDoctorConsultationTime={dataDoctorConsultationTime}
                    isViewCountWorkScheduleDetailPermitted={
                      isViewCountWorkScheduleDetailPermitted
                    }
                  />
                  <div>
                    <FieldArray
                      name='doctorSubsidy'
                      render={arrayHelpers => (
                        <div>
                          {values.doctorSubsidy
                            .slice(0, 5)
                            .map((item, index) => (
                              <div className='doctor-subsidy-container'>
                                <div className='doctor-subsidy__item'>
                                  {i18n.t('staff.workSchedule.doctorSubsidy')}
                                </div>
                                <div className='doctor-subsidy__item'>
                                  <div className='title'>
                                    {i18n.t('staff.workSchedule.subsidyName')}
                                  </div>
                                  <div>
                                    <InputText
                                      value={item.title}
                                      onChange={e => {
                                        setFieldValue(
                                          `doctorSubsidy[${index}].title`,
                                          e.target.value
                                        )
                                      }}
                                    />
                                    <ErrorMessage
                                      name={`doctorSubsidy[${index}].title`}
                                      component='div'
                                      className='signup-alert'
                                    />
                                  </div>
                                </div>
                                <div className='doctor-subsidy__item'>
                                  <div className='title'>
                                    {i18n.t('staff.workSchedule.subsidyValue')}
                                  </div>
                                  <div>
                                    <InputNumber
                                      size='medium'
                                      value={item.money}
                                      allowClear
                                      min={0}
                                      step={10}
                                      formatter={value =>
                                        `${value}`.replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ','
                                        )
                                      }
                                      type='tel'
                                      onChange={e => {
                                        setFieldValue(
                                          `doctorSubsidy[${index}].money`,
                                          e
                                        )
                                      }}
                                    />
                                    <ErrorMessage
                                      name={`doctorSubsidy[${index}].money`}
                                      component='div'
                                      className='signup-alert'
                                    />
                                  </div>
                                </div>
                                <div className='doctor-subsidy__item'>
                                  <Button
                                    type='button'
                                    icon='pi pi-trash'
                                    onClick={async () => {
                                      arrayHelpers.remove(index)
                                      if (item.id) {
                                        const oldValue = [
                                          ...values.removeDoctorSubsidyIds,
                                        ]
                                        oldValue.push(item.id)
                                        setFieldValue(
                                          'removeDoctorSubsidyIds',
                                          oldValue
                                        )
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      )}
                    />
                    <Button
                      type='button'
                      label={i18n.t('staff.workSchedule.btnSubsidy')}
                      icon='pi pi-plus'
                      disabled={values.doctorSubsidy.length >= 5}
                      onClick={() => {
                        if (values.doctorSubsidy.length < 5) {
                          setFieldValue('doctorSubsidy', [
                            ...values.doctorSubsidy,
                            {
                              title: '',
                              money: null,
                            },
                          ])
                        }
                      }}
                    />
                  </div>
                  <div className='tr'>
                    <div className='th'>
                      {i18n.t('staff.createDoctor.adjustHourlyWageRange')}
                    </div>
                    <div className='td'>
                      {numeralCurrency(doctorHourlyWageRange)}
                    </div>
                  </div>
                  <div className='tr'>
                    <div className='th'>{i18n.t('main.relatedShifts')}</div>
                  </div>
                  {values.doctorWorkSchedules.length > 0 ? (
                    <React.Fragment>
                      <div style={styles.related}>
                        <table className='table'>
                          <thead>
                            <tr>
                              <th style={styles.tableHeaderBg}>
                                {i18n.t('main.clinicName')}
                              </th>
                              <th style={styles.tableHeaderBg}>
                                {i18n.t('main.departmentName')}
                              </th>
                              <th style={styles.tableHeaderBg}>
                                {i18n.t('main.date')}
                              </th>
                              <th style={styles.tableHeaderBg}>
                                {i18n.t('main.startTime')}
                              </th>
                              <th style={styles.tableHeaderBg}>
                                {i18n.t('main.endTime')}
                              </th>
                              <th style={styles.tableHeaderBg}>
                                {i18n.t('main.status')}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {values.doctorWorkSchedules.map(
                              ({
                                id,
                                startTime,
                                endTime,
                                accepted,
                                clinicalDepartment,
                                deletedStatus,
                              }) =>
                                deletedStatus === 'WORKSCHEDULE_REJECT' ||
                                deletedStatus === 'WORKSCHEDULE_CANCEL' ||
                                deletedStatus ===
                                  'WORKSCHEDULE_DELETE' ? null : (
                                  <tr key={id}>
                                    <td>
                                      {ClinicNameRender({ clinicalDepartment })}
                                    </td>
                                    <td>
                                      {departmentNames[clinicalDepartment.name]}
                                    </td>
                                    <td>{moment(startTime).format('LL')}</td>
                                    <td>{formatExtendedTime(startTime, startTime)}</td>
                                    <td>{formatExtendedTime(startTime, endTime)}</td>
                                    <td>
                                      {accepted
                                        ? i18n.t('main.ACCEPTED')
                                        : i18n.t('main.NOT_ACCEPTED')}
                                    </td>
                                  </tr>
                                )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </React.Fragment>
                  ) : (
                    <div style={styles.empty}>
                      {i18n.t('staff.workSchedule.noWorkSchedule')}
                    </div>
                  )}
                  <div className='tr'>
                    <div className='th'>
                      {i18n.t('staff.availableShift.reasonKnowAboutShift')}
                    </div>
                    <div className='td'>
                      <CustomDropdown
                        {...formikProps}
                        style={{
                          minWidth: '300px',
                        }}
                        name='introductionHistory'
                        options={optionsKnowAboutShift}
                        placeholder={i18n.t(
                          'staff.availableShift.placeholderSelectReasonKnowAboutShift'
                        )}
                        changed={values.introductionHistory ? 'changed' : ''}
                      />
                    </div>
                  </div>
                  {values.introductionHistory === 'OTHER' ? (
                    <div className='tr'>
                      <div className='th'>
                        {i18n.t(
                          'staff.availableShift.detailReasonKnowAboutShift'
                        )}
                      </div>
                      <div className='td'>
                        <InputTextarea
                          {...formikProps}
                          name='introductionHistoryOther'
                        />
                      </div>
                    </div>
                  ) : null}
                  <div className='tr'>
                    <div className='th'>{i18n.t('main.postUpdateHistory')}</div>
                    <div className='td'>
                      <WorkScheduleActivityHistoryComponent
                        dataHistory={postUpdateHistory}
                      />
                    </div>
                  </div>
                  <div className='tr'>
                    <div className='th'>{i18n.t('main.updateHistory')}</div>
                    <div className='td'>
                      <WorkScheduleActivityHistoryComponent
                        dataHistory={activitiesHistory}
                        isActivitiesHistory={true}
                      />
                    </div>
                  </div>
                  <Accordion style={{ marginTop: '5px' }}>
                    <AccordionTab header={`${i18n.t('main.acceptedReason')}`}>
                      {!workSchedule.acceptedReason &&
                      !workSchedule.deletedReason ? (
                        <div className='tr'>
                          <div className='th' />
                          <div className='td'>
                            {i18n.t('main.emptyMessage')}
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className='tr'>
                            <div className='th'>
                              {i18n.t('main.acceptedReasonMessage')} :
                            </div>
                            <div className='td hidden-header'>
                              <Editor value={values.acceptedReason} readOnly />
                            </div>
                          </div>
                          <div className='tr'>
                            <div className='th'>
                              {i18n.t('main.deletedReasonCancel')} :
                            </div>
                            <div className='td'>
                              {workSchedule.deletedReason}
                            </div>
                          </div>
                        </>
                      )}
                    </AccordionTab>
                  </Accordion>
                  {!!state?.isshinTime && (
                    <div
                      className='tr'
                      style={{ display: 'flex', alignItems: 'start' }}
                    >
                      <div className='th'>
                        {i18n.t('main.consultationShiftTime')}
                      </div>
                      <div className='td'>
                        {state.isshinTime.split(', ').map(time => (
                          <>
                            {time}
                            <br />
                          </>
                        ))}
                      </div>
                    </div>
                  )}
                  {isGoldWare && (
                    <p style={{ color: 'red' }}>
                      ※確定シフト更新及びキャンセルについて、GoldWareアカウントの場合はメールが送信されません。
                    </p>
                  )}
                  <div className='modal-bottom'>
                    {values.deletedStatus === 'WORKSCHEDULE_CANCEL' &&
                    isRestorePermitted ? (
                      <Button
                        onClick={() => {
                          setFieldValue('functionName', restore)
                          setFieldValue('confirm', true)
                        }}
                        label='確定シフトキャンセル取消'
                        className='p-button-success'
                      />
                    ) : null}

                    {!values.accepted && (
                      <>
                        {isAcceptPermitted ? (
                          <>
                            <Button
                              disabled={!!!workSchedule?.acceptedShift}
                              onClick={() => {
                                setFieldValue(
                                  'updateIsAllowMultipleApplications',
                                  true
                                )
                              }}
                              label={
                                values.isAllowMultipleApplications
                                  ? '複数応募モードをオフにする'
                                  : '複数応募モードをオンにする'
                              }
                              className='p-button-secondary'
                            />
                            <Button
                              onClick={() => {
                                validateForm().then(response => {
                                  if (
                                    !Object.keys(response).filter(
                                      key =>
                                        ![
                                          'acceptedReason',
                                          'deletedReason',
                                          'rejectedReason',
                                        ].includes(key)
                                    ).length
                                  ) {
                                    const isExistAccepted = (
                                      values.doctorWorkSchedules ?? []
                                    ).filter(e => e.accepted)
                                    if (isExistAccepted.length) {
                                      setFieldValue(
                                        'acceptingAlreadyApprove',
                                        true
                                      )
                                    } else {
                                      setFieldValue('functionName', accept)
                                      setFieldValue('accepting', true)
                                    }
                                  } else {
                                    setTouched(response)
                                  }
                                })
                              }}
                              label={i18n.t('staff.acceptWorkSchedule.submit')}
                              className='p-button-success'
                              icon='pi pi-check'
                            />
                          </>
                        ) : null}

                        {isRejectPermitted ? (
                          <Button
                            onClick={() => {
                              setFieldValue('functionName', reject)
                              setFieldValue('rejecting', true)
                            }}
                            label={i18n.t('staff.rejectWorkSchedule.submit')}
                            className='p-button-danger'
                            icon='pi pi-trash'
                          />
                        ) : null}
                      </>
                    )}

                    {values.accepted && !values.deletedStatus ? (
                      <>
                        {isCancelPermitted ? (
                          <Button
                            onClick={() => {
                              setFieldValue('functionName', cancel)
                              setFieldValue('deleting', true)
                            }}
                            label={i18n.t('staff.cancelWorkSchedule.submit')}
                            className='p-button-danger'
                            icon='pi pi-trash'
                          />
                        ) : null}

                        {isUpdatePermitted ? (
                          <Button
                            label={i18n.t('staff.workSchedule.update')}
                            disabled={!dirty}
                            onClick={() => {
                              validateForm().then(response => {
                                if (
                                  !Object.keys(response).filter(
                                    key =>
                                      ![
                                        'acceptedReason',
                                        'deletedReason',
                                        'rejectedReason',
                                      ].includes(key)
                                  ).length
                                ) {
                                  setFieldValue('functionName', update)
                                  setFieldValue('updating', true)
                                } else {
                                  setTouched(response)
                                }
                              })
                            }}
                            icon='pi pi-pencil'
                          />
                        ) : null}

                        <Link
                          to={{
                            pathname: `${location.pathname
                              .split('/')
                              .slice(0, -2)
                              .join('/')
                              .replace(
                                'accepted_work_schedules_list',
                                'available_shifts'
                              )}${Router.staffCreateWorkSchedule}`,
                            states: {
                              ...values,
                              doctor: null,
                            },
                          }}
                        >
                          <Button label='複製' />
                        </Link>
                      </>
                    ) : null}
                  </div>
                  <ConfirmationModal
                    {...formikProps}
                    confirmationMessage={confirmationMessage}
                  />
                  <ConfirmationModal
                    {...formikProps}
                    handleSubmit={validateAndConfirm}
                    handleNoClick={() => {
                      setFieldValue('updating', false)
                      setFieldValue(
                        'acceptedReason',
                        initialValues.acceptedReason
                      )
                    }}
                    confirmationMessage={confirmationMessage}
                    visibleKey='updating'
                    isSendMail
                  >
                    {values.functionName === update && (
                      <div className='tr'>
                        <div className='th'>
                          {i18n.t('main.acceptedReason')}
                        </div>
                        <div className='td'>
                          <Editor
                            className='editor-responsive'
                            onTextChange={e =>
                              setFieldValue('acceptedReason', e.htmlValue)
                            }
                            value={values.acceptedReason}
                          />
                        </div>
                        <div className='alert'>
                          {touched.acceptedReason && errors.acceptedReason}
                        </div>
                      </div>
                      // <InputTextarea
                      //   {...formikProps}
                      //   name='acceptedReason'
                      //   label={i18n.t('main.acceptedReason')}
                      // />
                    )}
                  </ConfirmationModal>
                  <ConfirmationModal
                    {...formikProps}
                    handleSubmit={validateAndConfirm}
                    handleNoClick={() => {
                      setFieldValue('accepting', false)
                      setFieldValue(
                        'acceptedReason',
                        initialValues.acceptedReason
                      )
                    }}
                    confirmationMessage={confirmationMessage}
                    visibleKey='accepting'
                  >
                    {values.functionName === accept && (
                      <>
                        <div className='tr'>
                          <div className='th'>
                            {i18n.t('staff.workSchedule.doctorApply')}
                          </div>
                          <div
                            className='td'
                            style={{
                              paddingLeft: '20px',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <EmploymentClassificationIcon
                              workPattern={workSchedule.doctor.workPattern}
                            />
                            {workSchedule.doctor.fullName}
                          </div>
                        </div>
                        <div className='tr'>
                          <div className='th'>{i18n.t('main.workplace')}</div>
                          <div className='td' style={{ paddingLeft: '20px' }}>
                            {`${values.clinicName}_${
                              departmentNames[values.departmentName]
                            }`}
                          </div>
                        </div>
                        <div className='tr'>
                          <div className='th'>
                            {i18n.t(
                              'staff.workSchedule.noDoctorWorkedInClinic'
                            )}
                          </div>
                          <div className='td' style={{ paddingLeft: '20px' }}>
                            {countDoctorWorkedInClinic}
                          </div>
                        </div>
                        <div className='tr'>
                          <div className='th'>
                            {i18n.t('staff.workSchedule.isSendIntroduceMess')}
                          </div>
                          <div className='td' style={{ paddingLeft: '20px' }}>
                            <Checkbox
                              onChange={e => {
                                setFieldValue('isSendIntroduceMess', e.checked)
                                if (e.checked) {
                                  setFieldValue(
                                    'acceptedReason',
                                    workSchedule.clinicalDepartment.clinic
                                      .messageIntroduce
                                  )
                                }
                              }}
                              checked={values.isSendIntroduceMess}
                            />
                          </div>
                        </div>
                        {/* <InputTextarea
                          {...formikProps}
                          name='acceptedReason'
                          label={i18n.t('main.acceptedReason')}
                        /> */}
                        <div className='tr'>
                          <div className='th'>
                            {i18n.t('main.acceptedReason')}
                          </div>
                          <div className='td'>
                            <Editor
                              className='editor-responsive'
                              onTextChange={e =>
                                setFieldValue('acceptedReason', e.htmlValue)
                              }
                              value={values.acceptedReason}
                            />
                          </div>
                          <div className='alert'>
                            {touched.acceptedReason && errors.acceptedReason}
                          </div>
                        </div>
                      </>
                    )}
                  </ConfirmationModal>

                  <div className='accepting-already-modal-container'>
                    <ConfirmationModal
                      {...formikProps}
                      handleNoClick={() => {
                        setFieldValue('acceptingAlreadyApproveComment', true)
                        setFieldValue('acceptingAlreadyApprove', false)
                      }}
                      handleHideModal={() => {
                        setFieldValue('acceptingAlreadyApprove', false)
                      }}
                      handleSubmit={() => {
                        validateForm().then(response => {
                          if (
                            !Object.keys(response).filter(
                              key =>
                                ![
                                  'acceptedReason',
                                  'deletedReason',
                                  'rejectedReason',
                                ].includes(key)
                            ).length
                          ) {
                            setFieldValue('functionName', accept)
                            setFieldValue('accepting', true)
                          } else {
                            setTouched(response)
                          }
                          setFieldValue('acceptingAlreadyApprove', false)
                        })
                      }}
                      confirmationMessage={'確認・コメントは完了しましたか？'}
                      visibleKey='acceptingAlreadyApprove'
                      cancelText='コメントを確認する '
                      yesText='次へ'
                    >
                      <div>
                        <div
                          style={{
                            display: 'flex',
                            gap: '5px',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <div style={{ fontWeight: 'bold' }}>
                            応募勤務日全シフト
                          </div>
                          <div>
                            {values.doctorWorkSchedules.length > 0 ? (
                              <React.Fragment>
                                <div style={styles.related}>
                                  <table className='table'>
                                    <thead>
                                      <tr>
                                        <th style={styles.tableHeaderBg}>
                                          {i18n.t('main.clinicName')}
                                        </th>
                                        <th style={styles.tableHeaderBg}>
                                          {i18n.t('main.departmentName')}
                                        </th>
                                        <th style={styles.tableHeaderBg}>
                                          {i18n.t('main.date')}
                                        </th>
                                        <th style={styles.tableHeaderBg}>
                                          {i18n.t('main.startTime')}
                                        </th>
                                        <th style={styles.tableHeaderBg}>
                                          {i18n.t('main.endTime')}
                                        </th>
                                        <th style={styles.tableHeaderBg}>
                                          {i18n.t('main.status')}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {values.doctorWorkSchedules.map(
                                        ({
                                          id,
                                          startTime,
                                          endTime,
                                          accepted,
                                          clinicalDepartment,
                                        }) =>
                                          !accepted ? null : (
                                            <tr key={id}>
                                              <td>
                                                {ClinicNameRender({
                                                  clinicalDepartment,
                                                })}
                                              </td>
                                              <td>
                                                {
                                                  departmentNames[
                                                    clinicalDepartment.name
                                                  ]
                                                }
                                              </td>
                                              <td>
                                                {moment(startTime).format('LL')}
                                              </td>
                                              <td>
                                                {moment(startTime).format(
                                                  'HH:mm'
                                                )}
                                              </td>
                                              <td>
                                                {moment(endTime).format(
                                                  'HH:mm'
                                                )}
                                              </td>
                                              <td>{i18n.t('main.ACCEPTED')}</td>
                                            </tr>
                                          )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </React.Fragment>
                            ) : (
                              <div style={styles.empty}>
                                {i18n.t('staff.workSchedule.noWorkSchedule')}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </ConfirmationModal>
                  </div>
                  <div className='accepting-already-modal-container'>
                    <ConfirmationModal
                      {...formikProps}
                      handleNoClick={() => {
                        setFieldValue('acceptingAlreadyApproveComment', false)
                      }}
                      handleSubmit={() => {}}
                      confirmationMessage={'確認・コメントは完了しましたか？'}
                      visibleKey='acceptingAlreadyApproveComment'
                      footerUI={<CustomFooter />}
                    >
                      <div>
                        <div
                          style={{
                            gap: '3rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <div style={{ fontWeight: 'bold' }}>
                            応募勤務日全シフト
                          </div>
                          <div style={{ flexGrow: 1 }}>
                            <WorkScheduleComment
                              comments={workSchedule.staffComments}
                              availableShiftGroupComment={
                                workSchedule.acceptedShift
                                  .scheduledAvailableShiftGroup
                                  ? workSchedule.acceptedShift
                                      .scheduledAvailableShiftGroup
                                      .staffComments
                                  : null
                              }
                              workScheduleId={workSchedule.id}
                              staffId={staffMe.id}
                              isMoneyPermitted={isMoneyPermitted}
                              isAddPermitted={isAddPermitted}
                              isDeletePermitted={isDeletePermitted}
                              isDeleteAllComment={isDeleteAllComment}
                            />
                          </div>
                        </div>
                      </div>
                    </ConfirmationModal>
                  </div>
                  <ConfirmationModal
                    {...formikProps}
                    handleSubmit={validateAndConfirm}
                    handleNoClick={() => {
                      setFieldValue('deleting', false)
                      setFieldValue(
                        'deletedReason',
                        initialValues.deletedReason
                      )
                    }}
                    confirmationMessage={confirmationMessage}
                    visibleKey='deleting'
                  >
                    {values.functionName === cancel && !isGuaranteeShift && (
                      // <InputTextarea
                      //   {...formikProps}
                      //   name='deletedReason'
                      //   label={i18n.t('main.deletedReason')}
                      // />
                      <div className='tr'>
                        <div className='th'>{i18n.t('main.deletedReason')}</div>
                        <div className='td'>
                          <Editor
                            className='editor-responsive'
                            onTextChange={e =>
                              setFieldValue('deletedReason', e.htmlValue)
                            }
                            value={values.deletedReason}
                          />
                        </div>
                        <div className='alert'>
                          {touched.deletedReason && errors.deletedReason}
                        </div>
                      </div>
                    )}
                  </ConfirmationModal>
                  <ConfirmationModal
                    {...formikProps}
                    handleSubmit={validateAndConfirm}
                    handleNoClick={() => {
                      setFieldValue('rejecting', false)
                      setFieldValue(
                        'rejectedReason',
                        initialValues.rejectedReason
                      )
                    }}
                    confirmationMessage={confirmationMessage}
                    visibleKey='rejecting'
                  >
                    {values.functionName === reject && (
                      // <InputTextarea
                      //   {...formikProps}
                      //   name='rejectedReason'
                      //   label={`${i18n.t('main.deletedReason')}`}
                      // />
                      <div className='tr'>
                        <div className='th'>{i18n.t('main.deletedReason')}</div>
                        <div className='td'>
                          <Editor
                            className='editor-responsive'
                            onTextChange={e =>
                              setFieldValue('rejectedReason', e.htmlValue)
                            }
                            value={values.rejectedReason}
                          />
                        </div>
                        <div className='alert'>
                          {touched.rejectedReason && errors.rejectedReason}
                        </div>
                      </div>
                    )}
                  </ConfirmationModal>
                  <ConfirmationModal
                    {...formikProps}
                    handleSubmit={async () => {
                      await handleUpdateShiftAllowMultipleApplication({
                        workScheduleId: workSchedule.id,
                        isAllowMultipleApplications: !values.isAllowMultipleApplications,
                      })
                      setFieldValue(
                        'isAllowMultipleApplications',
                        !values.isAllowMultipleApplications
                      )
                      setFieldValue('updateIsAllowMultipleApplications', false)
                    }}
                    handleNoClick={() => {
                      setFieldValue('updateIsAllowMultipleApplications', false)
                    }}
                    confirmationMessage={confirmationMessage}
                    visibleKey='updateIsAllowMultipleApplications'
                  >
                    {values.isAllowMultipleApplications ? (
                      <>複数応募モードを無効にしてもよろしいですか？</>
                    ) : (
                      <>複数応募モードを有効にしてもよろしいですか？</>
                    )}
                  </ConfirmationModal>
                </div>
              </TabPanel>
              <TabPanel header={i18n.t('main.workScheduleDetailTab.comments')}>
                <div>
                  <div
                    className={
                      workSchedule.comment
                        ? 'doctor-comment'
                        : 'doctor-no-comment'
                    }
                  >
                    {workSchedule.comment ? (
                      <div className='doctor-comment-container'>
                        <div className='th'>
                          {i18n.t('main.workScheduleComment')}
                        </div>
                        <br />
                        <div className='doctor-comment-content'>
                          {workSchedule.comment}
                        </div>
                      </div>
                    ) : (
                      <div className='doctor-comment-container'>
                        <div className='th doctor-comment-title'>
                          {i18n.t('main.workScheduleComment')}
                        </div>
                        <br />
                        <div className='doctor-comment-content'>
                          {i18n.t('main.staffComment.emptyComment')}
                        </div>
                      </div>
                    )}
                  </div>
                  {isAddPermitted && (
                    <div className='staffpage-comment-container'>
                      <div className='staffpage-title'>
                        {i18n.t('main.staffComment.titleStaffComment')}
                      </div>
                      <WorkScheduleComment
                        comments={workSchedule.staffComments}
                        availableShiftGroupComment={
                          workSchedule.acceptedShift
                            .scheduledAvailableShiftGroup?.staffComments || null
                        }
                        workScheduleId={workSchedule.id}
                        staffId={staffMe.id}
                        isMoneyPermitted={isMoneyPermitted}
                        isAddPermitted={isAddPermitted}
                        isDeletePermitted={isDeletePermitted}
                        isDeleteAllComment={isDeleteAllComment}
                        isTabPanel
                      />
                    </div>
                  )}
                </div>
              </TabPanel>
              <TabPanel header={i18n.t('main.workScheduleDetailTab.workType')}>
                <WorkScheduleType
                  type={workSchedule.acceptedShift.type || ''}
                  workScheduleId={workSchedule.acceptedShift.id}
                  staffId={staffMe.id}
                  isTabPanel
                />
              </TabPanel>
            </TabView>
          )
        }}
      />
    </div>
  )
}

export default withRouter(DetailWorkScheduleScene)
